import Axios from 'axios'
import {activityPricingUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_pricings (context) {
    Axios.get(activityPricingUrls.getAllActivityPricings).then(function (response) {
      context.commit('GET_ALL_ACTIVITY_PRICINGS', response.data)
    })
  },
  get_current_activity_pricing (context, publicId) {
    Axios.get(activityPricingUrls.getCurrentActivityPricing + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_PRICINGS', response.data)
    })
  },
  get_activity_pricings (context, publicId) {
    Axios.get(activityPricingUrls.getActivityPricings + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_PRICINGS', response.data)
    })
  },
  get_deleted_activity_pricings (context) {
    Axios.get(activityPricingUrls.getDeletedActivityPricing).then(function (response) {
      context.commit('GET_DELETED_ACTIVITY_PRICINGS', response.data)
    })
  },
  get_activity_pricing (context, publicId) {
    Axios.get(activityPricingUrls.getActivityPricing + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_PRICING', response.data)
    })
  },
  post_activity_pricing (context, data) {
    Axios.post(activityPricingUrls.postActivityPricing, data).then(function () {
      context.dispatch('get_activity_pricings', data.public_id)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_activity_pricing (context, data) {
    Axios.post(activityPricingUrls.editActivityPricing, data).then(function () {
      context.dispatch('get_all_activity_pricings')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_activity_pricing (context, data) {
    Axios.post(activityPricingUrls.deleteActivityPricing + data.public_id, data).then(function (response) {
      context.dispatch('get_activity_pricings', data.inventory)
    })
  },
  restoreActivityPricing (context, publicId) {
    Axios.get(activityPricingUrls.restoreActivityPricing + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITY_PRICINGS', response.data)
      router.push({
        name: 'Module.ActivityPricings'
      })
    })
  }
}
